import { Usr_Log } from '../models/usr_log';

/**
 * @description
 * RecentObjectsCache is used to store and manage recently opened objects.
 */
export class RecentObjectsCache {
    private static instance: RecentObjectsCache;

    static getInstance() {
        if (!RecentObjectsCache.instance) {
            RecentObjectsCache.instance = new RecentObjectsCache();
        }

        return RecentObjectsCache.instance;
    }

    public usr_Logs: Array<any>
    public usr_LogsHMap: Map<string, any>;

    /**
    * RecentObjectsCache is a singleton class, so use RecentObjectsCache.getInstance() method instead of creating new RecentObjectsCache().
    */
    private constructor() {
        this.usr_Logs = new Array<any>();
        this.usr_LogsHMap = new Map<string, any>();
    }

    prepareUsr_Logs(usr_LogsTmp: Array<any>) {
        for (let i: number = 0; i < usr_LogsTmp.length; i++) {
            let usr_Log: Usr_Log = usr_LogsTmp[i];
            let usr_LogExist: Usr_Log = this.usr_LogsHMap[usr_Log.obj_Id + '-' + usr_Log.obj_Cd];

            if (usr_LogExist) {
                // update log..
            } else {
                usr_Log.imageUrl = 'assets/' + usr_Log.imageUrl.slice(4, usr_Log.imageUrl.length);
                this.usr_Logs.push(usr_Log);
                this.usr_LogsHMap[usr_Log.obj_Id + '-' + usr_Log.obj_Cd] = usr_Log;
            }
        }
    }

    unshift(obj_Id: any) {
        let usr_LogExist = this.usr_LogsHMap[obj_Id];
        if (!usr_LogExist) return;

        var index = this.usr_Logs.indexOf(usr_LogExist);
        if (index <= 0) return;

        this.usr_Logs.splice(index, 1);
        this.usr_Logs.unshift(usr_LogExist);
    }

    addUsr_Log(item: any) {
        //item.opened = true;
        //item.mode_Ind = 'W';
        if (item == undefined) return;
        item.imageUrl = 'assets/' + item.imageUrl.slice(4, item.imageUrl.length);
        let usr_LogExist = this.usr_LogsHMap[item.obj_Id];
        if (usr_LogExist) {
            if (usr_LogExist.change_Ind == "N")
                this.copyFromUsr_Log(usr_LogExist, item);

            this.unshift(item.obj_Id);
            return;
        }
        this.usr_LogsHMap[item.obj_Id] = item;
        this.usr_Logs.unshift(item);
    }

    updateUsr_Log(object: any, unLock: boolean = false) {
        object.opened = true;
        if (unLock) {
            //To do
            // object.mode_Ind = 'R';

            //object.opened = false;
        }

        let usr_Log = this.usr_LogsHMap[object.obj_Id];
        if (!usr_Log) return;

        this.copyFromUsr_Log(usr_Log, object);
    }

    deleteUsr_Log(obj_Id: number) {
        let usr_Log = this.usr_LogsHMap[obj_Id];
        if (!usr_Log) return;
        for(let i: number = 0; i < this.usr_Logs.length; i++) {
            if(this.usr_Logs[i].obj_Id != usr_Log.obj_Id) continue;
            this.usr_Logs.splice(i, 1);
            break;
        }
    }

    copyFromUsr_Log(object: any, objectCopy: any) {

        if (object.localFlag == 'Y')
            object.nm = objectCopy.name;

        if (objectCopy.name) {
            object.nm = objectCopy.name;
        }
        else {
            object.nm = objectCopy.nm;
        }

        object.change_Ind = objectCopy.change_Ind;
        object.valid_Cd = objectCopy.valid_Cd;

        object.opened = objectCopy.opened;
        object.mode_Ind = objectCopy.mode_Ind;
        object.imageUrl = objectCopy.imageUrl;

        object.streamingFlg = objectCopy.streamingFlg;
    }
}